// **********************************************************
// store Map
// **********************************************************

/* global L, windowWidth, breakpointMd, MAP_MAX_ZOOM, addOsmLayer, attachEvent */

const storeMapElements = document.querySelectorAll('.store-map__init');

const getMarkerClassNames = (isHQ, isRetailer) => {
  if (isHQ) {
    return {
      defaultClass: 'location-marker location-marker--hq',
      activeClass: 'location-marker--hq-active',
    };
  }

  if (isRetailer) {
    return {
      defaultClass: 'location-marker location-marker--retailer',
      activeClass: 'location-marker--retailer-active',
    };
  }

  return {
    defaultClass: 'location-marker location-marker--default',
    activeClass: 'location-marker--active',
  };
};

const zoomMapAroundPoint = (map, latLng, targetZoom) => {
  const clampedZoom = Math.min(map.getMaxZoom(), Math.max(map.getMinZoom(), targetZoom));

  if (clampedZoom === map.getZoom()) {
    return;
  }

  map.setZoomAround(latLng, clampedZoom, { animate: true });
};

const initStoreMapModule = () => {
  if (typeof L === 'undefined') return;

  const storeMapPinsEle = document.querySelectorAll('.store-map [data-marker]');
  const markers = [];
  const defaultZoom = Number(storeMapElements[0].getAttribute('data-zoom'));

  let activeMarker = null;
  let markersInitialized = false;

  const mapZoomAndPan = (map) => {
    if (windowWidth() >= breakpointMd) {
      map.setZoom(defaultZoom);
    }
  };

  const setCenterMap = (lat, lng, map) => {
    map.setView([Number(lat), Number(lng)], map.getZoom());
  };

  const focusMapOnMarker = (map, latLng) => {
    const markerLatLng =
      latLng?.lat != null ? L.latLng(latLng.lat, latLng.lng) : L.latLng(Number(latLng[0]), Number(latLng[1]));

    let targetZoom = map.getZoom();
    if (targetZoom <= defaultZoom) {
      targetZoom = Math.min(defaultZoom + 1, MAP_MAX_ZOOM);
    }

    let mapCenter = markerLatLng;

    if (windowWidth() >= breakpointMd) {
      const popupEl = document.querySelector('.store-map__popup-wrapper');
      const offsetX = popupEl ? popupEl.offsetWidth / 2 : 0;

      if (offsetX > 0) {
        const point = map.project(markerLatLng, targetZoom);
        mapCenter = map.unproject(point.add(L.point(offsetX, 0)), targetZoom);
      }
    }

    map.flyTo(mapCenter, targetZoom);
  };

  const scrollActiveLocationDetails = (card) => {
    const activeCard = card?.closest('.location-popup__dropdown-item');
    const scrollContainer = card
      ?.closest('.location-popup__dropdown')
      ?.querySelector('.location-popup__dropdown-inner');

    if (activeCard && scrollContainer) {
      scrollContainer.scrollTo({
        top: activeCard.offsetTop - 60,
        behavior: 'smooth',
      });
    }
  };

  const openPopup = (card) => {
    if (!card) return;

    const popupEle = card.closest('.location-popup');
    if (!popupEle) return;

    popupEle.classList.add('is-items-open');
    popupEle.querySelectorAll('.is-active').forEach((el) => el.classList.remove('is-active'));

    const navItem = card.closest('.location-popup__nav-item.has-dropdown');
    navItem?.classList.add('is-active');

    const details = card.closest('.location-details');
    details?.classList.add('is-active');

    scrollActiveLocationDetails(card);

    if (windowWidth() <= breakpointMd) {
      popupEle.classList.add('is-open');
    }

    const cardDataSlugElem = card.querySelector('[data-slug]');
    if (cardDataSlugElem) {
      const cardDataSlugValue = cardDataSlugElem.getAttribute('data-slug');
      if (cardDataSlugValue) {
        window.history.pushState({}, '', `#${cardDataSlugValue}`);
      }
    }
  };

  class AnimatedMarker {
    constructor(lat, lng, map, options = {}) {
      this.position = L.latLng(Number(lat), Number(lng));
      this.map = map;
      this.options = options;
      this.active = false;

      const div = document.createElement('div');
      div.className = this.options.defaultClass || 'custom-marker';
      div.style.cursor = 'pointer';

      if (this.options.icon) {
        const img = document.createElement('img');
        img.src = this.options.icon;
        img.alt = '';
        img.width = 100;
        img.height = 100;
        div.appendChild(img);
      }

      if (this.options.visible === false) {
        div.style.display = 'none';
      }

      const handleClick = (e) => {
        L.DomEvent.stopPropagation(e);
        this.options.onClick?.(this);
      };

      div.addEventListener('click', handleClick);

      this.div = div;

      const isHQ = Boolean(this.options.icon);
      this.leafletMarker = L.marker(this.position, {
        icon: L.divIcon({
          className: 'store-map-marker',
          html: div,
          iconSize: isHQ ? [100, 100] : [20, 20],
          iconAnchor: isHQ ? [50, 50] : [10, 10],
        }),
      }).addTo(map);
    }

    setActive(active) {
      this.active = active;
      if (!this.div) return;

      const { activeClass = 'is-active', defaultClass = '' } = this.options;

      this.div.className = defaultClass;

      if (active && activeClass) {
        this.div.classList.add(activeClass);
      }
    }

    getPosition() {
      return this.position;
    }

    setVisible(visible) {
      if (this.div) {
        this.div.style.display = visible ? 'block' : 'none';
      }
    }
  }

  const initMarkers = (pins, map) => {
    Array.prototype.forEach.call(pins, (elm) => {
      const pinLat = elm.getAttribute('data-marker-lat');
      const pinLng = elm.getAttribute('data-marker-lng');
      const markerSlug = elm.getAttribute('data-slug');
      const markerName = elm.getAttribute('data-tag');
      const infoCard = markerName ? document.querySelector(`.store-map [data-popup="${markerName}"]`) : null;
      const isCountryMarker = elm.classList.contains('location-popup__link');
      const isHQMarker = elm.classList.contains('store-map__hq');
      const isRetailer = Boolean(
        markerName && document.querySelector(`.store-map [data-tag="${markerName}"][data-type="retailer"]`),
      );
      const iconUrl = isHQMarker ? elm.getAttribute('data-marker') : null;
      const { defaultClass, activeClass } = isCountryMarker
        ? { defaultClass: '', activeClass: '' }
        : getMarkerClassNames(isHQMarker, isRetailer);

      const marker = new AnimatedMarker(pinLat, pinLng, map, {
        defaultClass,
        activeClass,
        visible: !isCountryMarker,
        icon: iconUrl,
        onClick: (m) => {
          if (activeMarker) activeMarker.setActive(false);
          activeMarker = m;
          m.setActive(true);
          focusMapOnMarker(map, m.getPosition());
          setTimeout(() => openPopup(infoCard), 200);

          if (isHQMarker) {
            const popupEle = document.querySelector('.location-popup');
            if (popupEle?.classList.contains('is-items-open') || popupEle?.classList.contains('is-open')) {
              popupEle.classList.remove('is-open');
              popupEle.querySelector('.location-popup__nav-item.is-active .location-popup__back-button')?.click();
            }
          }
        },
      });

      marker.slug = markerSlug;
      marker.locationItem = elm.closest('.location-popup__dropdown-item');

      elm.addEventListener('click', () => {
        activeMarker?.setActive(false);
        activeMarker = marker;
        marker.setActive(true);

        openPopup(infoCard);
        focusMapOnMarker(map, [pinLat, pinLng]);
      });

      markers.push(marker);
    });
  };

  const bindCooperativeTouchMap = (map) => {
    const mapContainer = map.getContainer();
    let dragMode = false;

    // Pinch-zoom always on; only single-finger pan waits for tap (cooperative scroll).
    map.touchZoom.enable();

    const setDragMode = (active) => {
      dragMode = active;
      mapContainer.classList.toggle('store-map--interactive', active);

      if (active) {
        map.dragging.enable();
        return;
      }

      map.dragging.disable();
    };

    setDragMode(false);

    mapContainer.addEventListener(
      'click',
      () => {
        setDragMode(true);
      },
      true,
    );

    mapContainer.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length >= 2) {
          mapContainer.classList.add('store-map--interactive');
        }
      },
      { capture: true, passive: true },
    );

    mapContainer.addEventListener(
      'touchend',
      (event) => {
        if (!dragMode && event.touches.length === 0) {
          mapContainer.classList.remove('store-map--interactive');
        }
      },
      { passive: true },
    );

    document.addEventListener('click', (event) => {
      if (!mapContainer.contains(event.target)) {
        setDragMode(false);
      }
    });
  };

  const bindDesktopMapInteraction = (map) => {
    // Custom +/- zoom uses setZoomAround at the pointer; Leaflet's keyboard handler would also zoom on center.
    map.keyboard.disable();

    const mapContainer = map.getContainer();
    mapContainer.setAttribute('tabindex', '0');
    let zoomFocusLatLng = map.getCenter();

    mapContainer.addEventListener('mouseenter', () => {
      mapContainer.focus({ preventScroll: true });
    });

    mapContainer.addEventListener('mousemove', (event) => {
      zoomFocusLatLng = map.mouseEventToLatLng(event);
    });

    mapContainer.addEventListener('keydown', (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey) {
        return;
      }

      let zoomDelta = 0;

      if (event.key === '+' || event.key === '=' || event.key === 'Add') {
        zoomDelta = map.options.zoomDelta;
      } else if (event.key === '-' || event.key === '_' || event.key === 'Subtract') {
        zoomDelta = -map.options.zoomDelta;
      }

      if (!zoomDelta) {
        return;
      }

      event.preventDefault();
      zoomMapAroundPoint(map, zoomFocusLatLng, map.getZoom() + zoomDelta);
    });

    mapContainer.addEventListener(
      'wheel',
      (event) => {
        // Normal wheel = page scroll; Ctrl/Cmd + wheel = zoom at pointer (Google Maps style).
        if (!event.ctrlKey && !event.metaKey) {
          return;
        }

        event.preventDefault();

        const { deltaY } = event;

        if (!deltaY) {
          return;
        }

        const direction = deltaY > 0 ? -1 : 1;
        const targetZoom = map.getZoom() + direction * map.options.zoomDelta;
        const zoomAt = map.mouseEventToLatLng(event);

        zoomMapAroundPoint(map, zoomAt, targetZoom);
      },
      { passive: false },
    );
  };

  const initialize = (el, mapLat, mapLng, mapZoom) => {
    const cooperativeTouch = windowWidth() < breakpointMd;

    const map = L.map(el, {
      zoomControl: false,
      attributionControl: true,
      zoomSnap: 1,
      zoomDelta: 1,
      wheelPxPerZoomLevel: 40,
      maxZoom: MAP_MAX_ZOOM,
      scrollWheelZoom: false,
    }).setView([Number(mapLat), Number(mapLng)], Number(mapZoom));

    if (cooperativeTouch) {
      bindCooperativeTouchMap(map);
    } else {
      bindDesktopMapInteraction(map);
    }

    addOsmLayer(map, { className: 'store-map-tiles' });

    const mobileZoom = () => {
      if (windowWidth() < breakpointMd) {
        map.setZoom(8);
      }
    };

    if (!markersInitialized) {
      initMarkers(storeMapPinsEle, map);
      markersInitialized = true;
    }

    mobileZoom();

    return map;
  };

  let primaryStoreMap = null;
  let primaryMapLat = null;
  let primaryMapLng = null;

  storeMapElements.forEach((el) => {
    const map = initialize(el, el.getAttribute('data-lat'), el.getAttribute('data-lng'), el.getAttribute('data-zoom'));

    if (!primaryStoreMap) {
      primaryStoreMap = map;
      primaryMapLat = el.getAttribute('data-lat');
      primaryMapLng = el.getAttribute('data-lng');
    }
  });

  attachEvent('.store-map .location-details__trigger', 'click', (ev) => {
    const locationDetails = ev.target.closest('.location-details');
    const mainParent = locationDetails?.closest('.location-popup');
    if (!mainParent || !locationDetails) return;

    mainParent.querySelectorAll('.location-details.is-active').forEach((node) => node.classList.remove('is-active'));
    locationDetails.classList.add('is-active');

    if (windowWidth() < breakpointMd) {
      mainParent.classList.remove('is-open');
    }
  });

  attachEvent('.store-map .location-popup__back-button', 'click', () => {
    if (!primaryStoreMap) return;

    setCenterMap(primaryMapLat, primaryMapLng, primaryStoreMap);
    mapZoomAndPan(primaryStoreMap);
  });

  const applyHashDeepLink = () => {
    const { hash } = window.location;
    if (!hash) return;

    const hashValue = hash.slice(1).toLowerCase();
    const escapedHash = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(hashValue) : hashValue;
    const targetElem = document.querySelector(`.store-map [data-slug="${escapedHash}"]`);

    if (!targetElem) return;

    targetElem.click();

    const targetMarker = markers.find((m) => m.slug?.toLowerCase() === hashValue);
    if (!targetMarker || activeMarker === targetMarker) return;

    activeMarker?.setActive(false);
    activeMarker = targetMarker;
    targetMarker.setActive(true);
  };

  applyHashDeepLink();

  const storeMapElem = document.querySelector('.store-map');
  const searchForm = storeMapElem?.querySelector('.location-popup__footer form');

  if (searchForm) {
    const locationPopup = searchForm.closest('.location-popup');
    const searchInput = searchForm.querySelector('#location_search');
    const notFoundKeyword = locationPopup.querySelector('.location-popup__not-found-keyword');
    const normalizeSearchTerm = (value) =>
      value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase()
        .trim();

    const filterLocations = (searchTerm = '') => {
      const normalizedSearchTerm = normalizeSearchTerm(searchTerm);
      let matchingLocations = 0;
      const countries = locationPopup.querySelectorAll('.location-popup__nav-item.has-dropdown');

      if (normalizedSearchTerm && countries.length > 1) {
        locationPopup.classList.remove('is-items-open');
        locationPopup.querySelector('.location-popup__nav-item.is-active')?.classList.remove('is-active');
      }

      countries.forEach((country) => {
        let countryMatches = 0;
        const countryName = country.querySelector('.location-popup__link-text')?.textContent || '';

        country.querySelectorAll('.location-popup__dropdown-item').forEach((item) => {
          const locationText = normalizeSearchTerm(`${countryName} ${item.textContent}`);
          const matches = !normalizedSearchTerm || locationText.includes(normalizedSearchTerm);
          item.hidden = !matches;
          countryMatches += Number(matches);
          matchingLocations += Number(matches);
        });

        country.hidden = Boolean(normalizedSearchTerm) && countryMatches === 0;
      });

      markers.forEach((marker) => {
        if (marker.locationItem) {
          marker.setVisible(!marker.locationItem.hidden);
        }
      });

      locationPopup.classList.toggle('no-result-found', Boolean(normalizedSearchTerm) && matchingLocations === 0);
      if (notFoundKeyword) {
        notFoundKeyword.textContent = normalizedSearchTerm ? `“${searchTerm}”` : '';
      }
    };

    searchForm.addEventListener('submit', (event) => {
      event.preventDefault();
      filterLocations(searchInput.value.trim());
    });

    attachEvent('.store-map .location-popup__not-found-back', 'click', (ev) => {
      ev.preventDefault();
      searchInput.value = '';
      filterLocations();
    });
  }
};

const bootStoreMapModule = () => {
  if (typeof L === 'undefined') return;
  initStoreMapModule();
};

if (storeMapElements.length > 0) {
  if (typeof L === 'undefined') {
    window.addEventListener('load', bootStoreMapModule, { once: true });
  } else {
    bootStoreMapModule();
  }
}
